import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, ReplaySubject } from 'rxjs';
import { retry, switchMap } from 'rxjs/operators';

import { getMatchingLanguage } from '../../utils/language';

export class TranslateHttpLoader implements TranslateLoader {
    private supportedLanguages$ = new ReplaySubject<string[]>(1);

    constructor(
        private http: HttpClient,
        public prefix: string = '/assets/i18n/',
        public suffix: string = '.json',
    ) {
        // A failed request would be replayed to every subscriber and permanently break i18n,
        // so absorb transient failures (e.g. requests dropped during app boot) with retries.
        this.http
            .get<string[]>(`${this.prefix}languages.json`)
            .pipe(retry({ count: 2, delay: 500 }))
            .subscribe(this.supportedLanguages$);
    }

    getTranslation(lang: string): Observable<TranslationObject> {
        return this.supportedLanguages$.pipe(
            switchMap((languages) => {
                const matchingLanguage = getMatchingLanguage(lang, languages);
                return this.http.get<TranslationObject>(`${this.prefix}${matchingLanguage}${this.suffix}`);
            }),
            retry({ count: 2, delay: 500 }),
        );
    }
}
